import type { GovernmentCustomizationsFooter } from '@govinity/validation';
import { PublicPortalFooter } from '@govinity/ui/components/blocks/public-portal-footer';
import { LOGO_URL, NEW_FULL_LOGO_URL_DARK, NEW_FULL_LOGO_URL_LIGHT } from '@/lib/constants/logo';

interface FooterProps {
  footerData: GovernmentCustomizationsFooter | null;
  governmentName: string;
  logoClickUrl?: string | null;
}

export const Footer = ({ footerData, governmentName, logoClickUrl }: FooterProps) => {
  return (
    <PublicPortalFooter
      footerData={footerData}
      governmentName={governmentName}
      lightLogoUrl={NEW_FULL_LOGO_URL_LIGHT}
      darkLogoUrl={NEW_FULL_LOGO_URL_DARK}
      logoUrl={LOGO_URL}
      logoClickUrl={logoClickUrl}
    />
  );
};
